import MapOutlined from '@material-ui/icons/MapOutlined'

const totalOfWeeks = 6
export const weekLength = 7
export const totalDays = totalOfWeeks * weekLength
export const lengthOfDayInPx = 24

export const labelActivityType = {
  mapping: {
    label: 'Mapeamento',
    icon: <MapOutlined />,
  },
  mosaicking: {
    label: 'Mosaicamento',
    icon: <span className='material-symbols-outlined'>grid_4x4</span>,
  },
  diagnosis: {
    label: 'Diagnóstico',
    icon: (
      <span className='material-symbols-outlined'>auto_awesome_motion</span>
    ),
  },
  pulverization: {
    label: 'Pulverização',
    icon: <span className='material-symbols-outlined rotate'>sprinkler</span>,
  },
}

export const activityStatus = {
  overdue: {
    borderColor: '#BA1B1B',
    backgroundColor: '#FFDAD4',
  },
  done: {
    borderColor: '#727970',
    backgroundColor: '#C6C7C2',
  },
  in_progress: {
    borderColor: '#55AFCB',
    backgroundColor: '#A5C5D7',
  },
}
